import obsDoc from "./obsDoc";

export async function addPage(doc, cursorY) {
  // Auto-paging
  doc.addPage();
  cursorY = obsDoc.pageWrapInitialYPosition;
  //Header & footer logo
  // await addHeaderAndFooter(doc);
  cursorY += obsDoc.headerSpacing; //make room for header
  return cursorY;
}
